export default __webpack_public_path__ + "static/media/ai-bg.582b9bfb.png";